
import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { useAccesos } from '../contexts/AccesosContext';




function AddTipoGasto ({ handleNewTipoGasto, editTipoGasto, cancelarEdicion}){
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [descripcion, setDescripcion] = useState('');
    const [modificacion, setModificacion] = useState('');
    const [IngresadoPor, setIngresadoPor] = useState('');

    const { user } = useUser();
    const { tienePermiso } = useAccesos();
        // Obtener la fecha y hora actual
        function obtenerFechaISOsinZ() {
            const fecha = new Date();
            let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
            fechaISO = fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
            return fechaISO;
    }

    // Convertir a una cadena en formato ISO 8601
        const fechaFormateada = obtenerFechaISOsinZ();
        // Carga inicial de datos si estamos en modo edición
        useEffect(() => {
            if (editTipoGasto) {
                setDescripcion(editTipoGasto.tipoGasto); // Cargar la descripción de la raza para editar
                setModificacion(2);
                setIngresadoPor(editTipoGasto.ingresadoPor);
    
            } else {
                setDescripcion(''); // Resetear la descripción si no estamos editando
                setModificacion(1);
                setIngresadoPor('');
    
            }
        }, [editTipoGasto]);
    
        const handleSubmit = async (e) => {
            e.preventDefault();
            const method = editTipoGasto ? 'PUT' : 'POST'; // Usar PUT para actualizar y POST para crear
            const endpoint = editTipoGasto ? `${server}/CrmTipoGastoCampaniums/${editTipoGasto.id}` : `${server}/CrmTipoGastoCampaniums`;
    
            const tipoGasto = { 
                id:editTipoGasto ? editTipoGasto.id:0,
                tipoGasto: descripcion,
                IngresadoPor: !editTipoGasto ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
                ModificadoPor: editTipoGasto ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
                fechaIngreso: fechaFormateada
            };
            Object.keys(tipoGasto).forEach(key => tipoGasto[key] === undefined && delete tipoGasto[key]);
    
            try {
                const response = await fetch(endpoint, {
                    method: method,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(tipoGasto),
                });
    
                if (response.ok) {
                    // Limpiar el formulario y manejar la respuesta si es necesario
                    setDescripcion('');
                    Swal.fire({
                        icon: 'success',
                        title: 'Operación exitosa',
                        showConfirmButton: false,
                        timer: 1500
                    });         
                           handleNewTipoGasto();
                } else {
                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });            }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al guardar la raza',
                    text: error || 'Ocurrió un error inesperado',
                });        }
        };

    
        const handleCancelarEdicion = () => {
            setDescripcion('');
            setModificacion(1);
            setIngresadoPor('');
            if (cancelarEdicion) cancelarEdicion();
        };

    return (
        <>
        {/* <h2>{editEtnia ? 'Editar Etnia' : 'Agregar Nueva Etnia'}</h2> */}
        <h2>{editTipoGasto ? 'Editar Tipo de Gasto' : 'Agregar Nueva Tipo de Gasto'}</h2>
        <br />
        <form id="formTipoGasto" className="form-horizontal form-label-left" onSubmit={handleSubmit}>
            <div className="item form-group">
                <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="descripcionTipoGasto">
                    Descripción: <span className="required">*</span>
                </label>
                <div className="col-md-2 col-sm-3">
                    <input
                        type="text"
                        id="descripcionTipoGasto"
                        required="required"
                        className="form-control"
                        value={descripcion}
                        onChange={(e) => setDescripcion(e.target.value)}
                    />
                </div>
            </div>

            <div className="ln_solid" />
            <div className="item form-group">
                <div className="col-md-6 col-sm-6 offset-md-3">
                    <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Tipo Gasto')}>
                        {editTipoGasto ? 'Actualizar' : 'Guardar'}
                    </button>
                    {editTipoGasto && (
                        <button type="button" className="btn btn-secondary" onClick={handleCancelarEdicion}>
                            Cancelar
                        </button>  
                    )}
                </div>
            </div>
        </form>
    </>
    )
}


export default AddTipoGasto;